module.exports = __webpack_public_path__ + "img/maidanglao.aeec222d.png";